import { Routes } from '@angular/router';
import { Route } from './core/route.service';
import { importProvidersFrom } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuthenticationGuard } from './core/authentication/authentication.guard';

export const routes: Routes = Route.withShell([
  {
    path: '',
    children: [
      /*{
       path: '',
       loadComponent: () => {
         return import('./loading/loading_component/loading.component').then(
           (m) => m.LoadingComponent
         );
       },
       providers: [
         importProvidersFrom(TranslateModule.forChild({ extend: true })),
       ],
       //canActivate: [AuthenticationGuard],
     },*/
      {
        path: 'pdf',
        loadComponent: () => {
          return import('./pdf/pdf.component').then(
            (m) => m.PdfComponent
          );
        },
        providers: [
          importProvidersFrom(TranslateModule.forChild({ extend: true })),
        ],
        //canActivate: [AuthenticationGuard],
      },
      {
        path: 'view-pdf',
        loadComponent: () => {
          return import('./view-pdf/view-pdf.component').then(
            (m) => m.ViewPdfComponent
          );
        },
        providers: [
          importProvidersFrom(TranslateModule.forChild({ extend: true })),
        ],
        //canActivate: [AuthenticationGuard],
      }
    ]
  }
]);
